import * as React from 'react';
import { SVGProps } from 'react';

const SvgTwitter = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16 2c-.6.3-1.2.4-1.9.5.7-.4 1.2-1 1.4-1.8-.6.4-1.3.6-2.1.8-.6-.6-1.5-1-2.4-1-2.1 0-3.7 2-3.2 4C5.1 4.4 2.7 3.1 1 1.1.1 2.6.6 4.5 2 5.5c-.5 0-1-.2-1.5-.4C.5 6.6 1.6 8 3.1 8.4c-.5.1-1 .2-1.5.1.4 1.3 1.6 2.3 3.1 2.3-1.2.9-3 1.4-4.7 1.2 1.5.9 3.2 1.5 5 1.5 6.1 0 9.5-5.1 9.3-9.8.7-.4 1.3-1 1.7-1.7Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgTwitter;
